const Share = () => {
  console.log('Video');
};

export { Share };
